import React, { useContext, useState, useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Keyboard, Mousewheel } from 'swiper/core';
import { breakpoints } from '../utils/helpers';
import Play from "-!svg-react-loader!../assets/images/icons/play-button.svg"
import Close from "-!svg-react-loader!../assets/images/close.svg"
import Image from './image';
import { StaticImage } from 'gatsby-plugin-image';
import { StoreContext } from '../context/store-context';
import 'swiper/css';
import 'swiper/css/effect-fade';

const ProductGallery = ({ allMedia, defaultImage, productTitle }) => {
  const [play, setPlay] = useState(false)
  const [moreVisible, setMoreVisible] = useState(false)
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [featuredSwiper, setFeaturedSwiper] = useState(null)
  const [modalThumbsSwiper, setModalThumbsSwiper] = useState(null)
  const [modalFeaturedSwiper, setModalFeaturedSwiper] = useState(null)
  const [featuredImage, setFeaturedImage] = useState({
    'source': defaultImage,
    'type': 'IMAGE',
    'videoSrc': null,
  })
  const [featuredImageHidden, setFeaturedImageHidden] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeModalIndex, setActiveModalIndex] = useState(0)
  const { conCurrentVariant } = useContext(StoreContext)
  const video = useRef(null)
  const swiperRef = useRef(null)

  useEffect(() => {
    if (!conCurrentVariant || !conCurrentVariant.media || !conCurrentVariant.media[0]?.image.originalSrc) return;

    const matchingIndex = allMedia.findIndex(media => media.image.originalSrc === conCurrentVariant.media[0].image.originalSrc);
    if (matchingIndex !== -1) {
      featuredSwiper?.slideTo(matchingIndex);
    }
  }, [conCurrentVariant, featuredSwiper, allMedia])

  useEffect(() => {
    if (moreVisible && thumbsSwiper && featuredSwiper) {
      const handleSlideChange = () => {
        if (thumbsSwiper.activeIndex !== featuredSwiper.activeIndex) {
          thumbsSwiper.slideTo(featuredSwiper.activeIndex);
        }
      };
      featuredSwiper.on('slideChange', handleSlideChange);

      return () => {
        featuredSwiper.off('slideChange', handleSlideChange);
      };
    }
  }, [moreVisible, thumbsSwiper, featuredSwiper]);

  useEffect(() => {
    if (thumbsSwiper) {
      thumbsSwiper.update();
      thumbsSwiper.allowTouchMove = moreVisible;
      thumbsSwiper.freeMode = moreVisible;
    }
  }, [moreVisible, thumbsSwiper]);

  useEffect(() => {
    if (play) {
      video.current.play();
    }
  }, [play])

  useEffect(() => {
    if (thumbsSwiper && featuredSwiper) {
      thumbsSwiper.slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          featuredSwiper.slideTo(index);
        });
      });

      return () => {
        thumbsSwiper.slides?.forEach((slide, index) => {
          slide.removeEventListener('click', () => {
            featuredSwiper.slideTo(index);
          });
        });
      };
    }
  }, [thumbsSwiper, featuredSwiper])

  useEffect(() => {
    if (modalThumbsSwiper && modalFeaturedSwiper) {
      modalThumbsSwiper.slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          modalFeaturedSwiper.slideTo(index);
        });
      });

      return () => {
        modalThumbsSwiper.slides?.forEach((slide, index) => {
          slide.removeEventListener('click', () => {
            modalFeaturedSwiper.slideTo(index);
          });
        });
      };
    }
  }, [modalThumbsSwiper, modalFeaturedSwiper])

  useEffect(() => {
    if (modalFeaturedSwiper && modalThumbsSwiper) {
      const handleSlideChange = () => {
        if (modalThumbsSwiper.activeIndex !== modalFeaturedSwiper.activeIndex) {
          modalThumbsSwiper.slideTo(modalFeaturedSwiper.activeIndex);
        }
      };
      modalFeaturedSwiper.on('slideChange', handleSlideChange);

      return () => {
        modalFeaturedSwiper.off('slideChange', handleSlideChange);
      };
    }
  }, [modalFeaturedSwiper, modalThumbsSwiper]);

  useEffect(() => {
    if (modalThumbsSwiper) {
      modalThumbsSwiper.update();
    }
    if (modalFeaturedSwiper) {
      modalFeaturedSwiper.update();
    }
  }, [modalThumbsSwiper, modalFeaturedSwiper]);

  const handleImageClick = (index) => {
    if (window.innerWidth > breakpoints.md) {
      setActiveModalIndex(index)
      setIsModalOpen(true)
    }
  }

  const closeModal = () => {
    setIsModalOpen(false);
  }

  const handleMoreButtonClick = () => {
    setMoreVisible(true)
    setIsModalOpen(true)

    featuredSwiper.slideTo(4)
    thumbsSwiper.slideTo(4)
  }

  if (!allMedia) { return null; }

  SwiperCore.use([Keyboard, Mousewheel])

  return (
    <div className="ProductPage__gallery">
      {/* Thumbnails */}
      <div className="ProductPage__gallery__thumbnails">
        <Swiper
          ref={swiperRef}
          watchSlidesProgress
          onSwiper={setThumbsSwiper}
          slidesPerView={5}
          direction={"horizontal"}
          freeMode={moreVisible}
          spaceBetween={20}
          draggable={moreVisible}
          allowTouchMove={moreVisible}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          speed={500}
          className="ProductPage__gallery__thumbnails__carousel"
          breakpoints={{
            [breakpoints.sm]: {
              slidesPerView: 5,
              direction: 'vertical',
              spaceBetween: 15,
            },
          }}
        >
          {allMedia.length > 0 ? (
            allMedia.map((media, index) => {
              if (index === 4 && !moreVisible) {
                return (
                  <SwiperSlide key="more">
                    <button
                      onClick={handleMoreButtonClick}
                      className="notbutton ProductPage__gallery__thumbnail__wrapper"
                    >
                      <p className='ProductPage__gallery__thumbnail__wrapper__more'>+{allMedia.length - 4}</p>
                    </button>
                  </SwiperSlide>
                );
              } else {
                const mediaType = media.mediaContentType;
                const mediaSource = mediaType === 'VIDEO' ? media.preview.image : media.image;
                const videoSrc = mediaType === 'VIDEO' ? media.sources[0].url : null;
                return (
                  <SwiperSlide key={index}>
                    <button
                      className={`notbutton ProductPage__gallery__thumbnail__wrapper ProductPage__gallery__thumbnail__wrapper--${mediaType.toLowerCase()}`}
                      onClick={() => {
                        setFeaturedImage({
                          'source': mediaSource,
                          'type': mediaType,
                          'videoSrc': videoSrc,
                        });
                        setFeaturedImageHidden(false);
                        setPlay(false);
                      }}
                    >
                      <Image
                        source={mediaSource}
                        imgClass={`ProductPage__gallery__thumbnail ProductPage__gallery__thumbnail`}
                      />
                      {mediaType.toLowerCase() === 'video' && (
                        <Play />
                      )}
                    </button>
                  </SwiperSlide>
                );
              }
            })
          ) : (
            <SwiperSlide>
              <button className="notbutton ProductPage__gallery__thumbnail__wrapper ProductPage__gallery__thumbnail__wrapper--image">
                <StaticImage
                  src="../assets/images/scroll-logo.png"
                  alt={'product thumbnail'}
                  className="ProductPage__gallery__thumbnail ProductPage__gallery__thumbnail no-image"
                />
              </button>
            </SwiperSlide>
          )}
        </Swiper>
      </div>

      {/* Featured Image */}
      <div className="ProductPage__gallery__featured">
        {allMedia.length > 0 ? (
          <Swiper
            slidesPerView={1}
            onSwiper={setFeaturedSwiper}
            effect='fade'
            fadeEffect={{ crossFade: true }}
            speed={500}
            loop={false}
          >
            <button
              className="Featured__prev__button"
              onClick={() => featuredSwiper && featuredSwiper.slidePrev()}
              onKeyUp={() => featuredSwiper && featuredSwiper.slidePrev()}
              aria-label="Previous"
            ></button>
            {allMedia.map((media, index) => {
              const mediaType = media.mediaContentType;
              const mediaSource = mediaType === 'VIDEO' ? media.preview.image : media.image;

              return (
                <SwiperSlide key={index}>
                  <div
                    className={`ProductPage__gallery__featured__image__wrap ProductPage__gallery__featured__image__wrap--${featuredImage.type.toLowerCase()}`}
                    onClick={() => handleImageClick(index)} // Open modal
                    onKeyUp={() => handleImageClick(index)}
                    role="presentation"
                  >
                    <Image
                      source={mediaSource}
                      imgClass={`ProductPage__gallery__featured__image ${featuredImageHidden ? ' ProductPage__gallery__featured__image--hide' : ''}`}
                    />
                    {mediaType.toLowerCase() === 'video' && (
                      <div className="Play__button" hidden={play}>
                        <Play onClick={() => setPlay(true)} />
                      </div>
                    )}
                    {mediaType === 'VIDEO' && (
                      /* eslint-disable-next-line jsx-a11y/media-has-caption */
                      <video
                        className="ProductPage__gallery__featured__video"
                        src={media.sources[0].url}
                        autoPlay={false}
                        ref={video}
                        controls
                        onClick={() => setPlay(true)}
                      />
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
            <button
              className='Featured__next__button'
              onClick={() => featuredSwiper && featuredSwiper.slideNext()}
              onKeyUp={() => featuredSwiper && featuredSwiper.slideNext()}
              aria-label="Next"
            ></button>
          </Swiper>
        ) :
          (<StaticImage
            src="../assets/images/scroll-logo.png"
            alt={'product thumbnail'}
            className="no-image"
          />)
        }
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="ProductPage__gallery__modal">
          <div className="ProductPage__gallery__modal__overlay"
            onClick={closeModal}
            onKeyUp={closeModal}
            role="presentation"
          ></div>
          <div className="ProductPage__gallery__modal__content">
            <button
              className="ProductPage__gallery__modal__close notbutton"
              onClick={closeModal}
              onKeyUp={closeModal}
              aria-label="Close"
            ><Close/></button>
            <div className="ProductPage__gallery__modal__content__header">
              <h4>{productTitle}</h4>
            </div>
            <div className="ProductPage__gallery__modal__content__inner">
              <div className="ProductPage__gallery__modal__content__inner__thumb">
                <Swiper
                  onSwiper={setModalThumbsSwiper}
                  slidesPerView={allMedia.length > 0 ? allMedia.length : 2}
                  direction={"vertical"}
                  freeMode={true}
                  spaceBetween={0}
                  draggable={true}
                  allowTouchMove={true}
                  effect="fade"
                  fadeEffect={{ crossFade: true }}
                  speed={500}
                  className="ProductPage__gallery__modal__content__inner__thumb__carousel"
                  initialSlide={activeModalIndex}
                  // breakpoints={{
                  //   [breakpoints.sm]: {
                  //     slidesPerView: 5,
                  //     spaceBetween: 15,
                  //   },
                  // }}
                >
                  {allMedia.length > 0 ? (
                    allMedia.map((media, index) => {
                      const mediaType = media.mediaContentType;
                      const mediaSource = mediaType === 'VIDEO' ? media.preview.image : media.image;
                      const videoSrc = mediaType === 'VIDEO' ? media.sources[0].url : null;
                      return (
                        <SwiperSlide key={index}>
                          <button
                            className={`notbutton ProductPage__gallery__thumbnail__wrapper ProductPage__gallery__thumbnail__wrapper--${mediaType.toLowerCase()}`}
                            onClick={() => {
                              setFeaturedImage({
                                'source': mediaSource,
                                'type': mediaType,
                                'videoSrc': videoSrc,
                              });
                              setFeaturedImageHidden(false);
                              setPlay(false);
                            }}
                          >
                            <Image
                              source={mediaSource}
                              imgClass={`ProductPage__gallery__thumbnail ProductPage__gallery__thumbnail`}
                            />
                            {mediaType.toLowerCase() === 'video' && (
                              <Play />
                            )}
                          </button>
                        </SwiperSlide>
                      );
                    })
                  ) : (
                    <SwiperSlide>
                      <button className="notbutton ProductPage__gallery__thumbnail__wrapper ProductPage__gallery__thumbnail__wrapper--image">
                        <StaticImage
                          src="../assets/images/scroll-logo.png"
                          alt={'product thumbnail'}
                          className="ProductPage__gallery__thumbnail ProductPage__gallery__thumbnail no-image"
                        />
                      </button>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
              <div className="ProductPage__gallery__modal__content__inner__featured">
                {allMedia.length > 0 ? (
                  <Swiper
                    onSwiper={setModalFeaturedSwiper}
                    slidesPerView={1}
                    initialSlide={activeModalIndex}
                    effect='fade'
                    fadeEffect={{ crossFade: true }}
                    speed={500}
                    loop={false}
                    className="ProductPage__gallery__modal__content__inner__featured__carousel"
                  >
                    <button
                      className="Featured__prev__button"
                      onClick={() => modalFeaturedSwiper && modalFeaturedSwiper.slidePrev()}
                      onKeyUp={() => modalFeaturedSwiper && modalFeaturedSwiper.slidePrev()}
                      aria-label="Previous"
                    ></button>
                    {allMedia.map((media, index) => {
                      const mediaType = media.mediaContentType;
                      const mediaSource = mediaType === 'VIDEO' ? media.preview.image : media.image;

                      return (
                        <SwiperSlide key={index}>
                          <div
                            className={`ProductPage__gallery__featured__image__wrap ProductPage__gallery__featured__image__wrap--${featuredImage.type.toLowerCase()}`}
                          >
                            <Image
                              source={mediaSource}
                              imgClass={`ProductPage__gallery__featured__image ${featuredImageHidden ? ' ProductPage__gallery__featured__image--hide' : ''}`}
                            />
                            {mediaType.toLowerCase() === 'video' && (
                              <div className="Play__button" hidden={play}>
                                <Play onClick={() => setPlay(true)} />
                              </div>
                            )}
                            {mediaType === 'VIDEO' && (
                              /* eslint-disable-next-line jsx-a11y/media-has-caption */
                              <video
                                className="ProductPage__gallery__featured__video"
                                src={media.sources[0].url}
                                autoPlay={false}
                                ref={video}
                                controls
                                onClick={() => setPlay(true)}
                              />
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                    <button
                      className='Featured__next__button'
                      onClick={() => modalFeaturedSwiper && modalFeaturedSwiper.slideNext()}
                      onKeyUp={() => modalFeaturedSwiper && modalFeaturedSwiper.slideNext()}
                      aria-label="next"
                    ></button>
                  </Swiper>
                ) :
                  (<StaticImage
                    src="../assets/images/scroll-logo.png"
                    alt={'product thumbnail'}
                    className="no-image"
                  />)
                }
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
